import { render, staticRenderFns } from "./IdentityResourceDetail.vue?vue&type=template&id=0a6eb8d1&"
import script from "./IdentityResourceDetail.vue?vue&type=script&lang=js&"
export * from "./IdentityResourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports